import React from "react";
import { CheckboxWrapper } from "./style";

export const CheckBox = props => {
  const {
    input,
    checked,
    color,
    onSelect,
    disabled,
    label,
    children,
    checkedColor
  } = props;
  let isChecked = checked;
  let onChange = onSelect;
  if (input) {
    isChecked = input.value;
    onChange = () => input.onChange(!isChecked);
  }
  return (
    <CheckboxWrapper
      checkedColor={checkedColor}
      checked={isChecked}
      disabled={disabled}
      onClick={e => {
        if (!disabled) {
          e.stopPropagation();
          onChange && onChange();
        }
      }}
    >
      {label || children}
    </CheckboxWrapper>
  );
};
